import script from "./PartnerRequestTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerRequestTableItem.vue?vue&type=script&setup=true&lang=js"

import "./PartnerRequestTableItem.vue?vue&type=style&index=0&id=f1e76f5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1e76f5a"]])

export default __exports__